const state = {
  baseUrl: "",
  defaults: {
    apiGetConfig: "api/webproduct/getConfig/",
    apiGetCompletePersonalization: "personalization/completePersonalization",
    apiGet: "api/webproduct/get",
    apiUpload: "api/upload",
    apiChangeOption: "api/webproduct/changeOptions",
    packingGetData: "packing/getData",
    packingGetPdf: "packing/getPdf",
    packingGetCf2: "packing/getCF2",
    checkPreflight: "api/upload/checkPreflight",
    deleteFile: "api/upload/deleteFile",
    getPersonalizeUrl: "personalization/computeUrl",
    getPdfUploadPreview: "api/upload/preview",
    connectUpload: "api/produce/connectItem", //"api/webproduct/connectProduct/index",
    mediaBaseUrl: "storage/",
    apiCustomerGalleryUrl: "api/media/gallery",
    apiDeleteImageUrl: "api/media/delete/",
    generatePdf: "",
    uploadUserPhotoUrl: "api/media",
    getResizedImageUrl: "api/media/working/",
    workingsUrl: "api/media/workings",
    rearrangePdf: "api/upload/edit",
    cimpressGetToken: "",
    cimpressValidate: "",
    quotationUrl: "",
    apiChangeOptionGetPrices: "api/cimpress/priceMatrix"
  },
  customUrls: {}
};

const getters = {
  getBaseUrl: state => {
    return state.baseUrl;
  },
  getUrl: state => url => {
    if (state.customUrls[url]) {
      return state.customUrls[url];
    }
    return state.baseUrl + state.defaults[url];
  },
  getuploadUserPhotoUrl: (state, getters) => {
    return getters.getUrl("uploadUserPhotoUrl");
  },
  getIsQuotationUrlSet: state => {
    return state.customUrls["quotationUrl"] ? true : false;
  }
};

const mutations = {
  setCustomUrls: (state, payload) => {
    state.customUrls = payload;
  },
  setBaseUrl: (state, payload) => {
    state.baseUrl = payload;
  }
};

const actions = {
  setCustomUrls: ({ commit }, payload) => {
    commit("setCustomUrls", payload);
  },
  setBaseUrl: ({ commit }, payload) => {
    commit("setBaseUrl", payload);
  },
  setUrls: ({ commit }, payload) => {
    var urls = { ...payload };
    if (payload.base_url) {
      delete urls.base_url;
      commit("setBaseUrl", payload.base_url);
    }
    commit("setCustomUrls", urls);
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
